import { Api } from "../Api";

export const carregaCredorInfo = async (e) => {
  const { data } = await Api.get(`users/searchbyid/${e}`);
  return data;
};

export const carregaDevedorInfo = async (e) => {
  const { data } = await Api.get(`users/searchbyid/${e}`);
  return data;
};

export const carregaFinanceiraInfo = async (e) => {
  const { data } = await Api.get(`/credorPlataformaPagamento/consulta/${e}`);
  return data;
};

export const carregaIP = async (e) => {
  const { data } = await Api.get("ip");
  return data;
};

export const carregaPrejuizoBoleto = async (e) => {
  const { provider_id, usuario_id } = e;
  const { data } = await Api.get(`cobranca/prejuizo/${provider_id}/${usuario_id}/10/0`);
  return data;
};

export const salvaLogCredor = async (e) => {
  const { data } = await Api.post("log/login", e);
  return data;
};
